import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "number" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["milestone-badge", {'achieved': $options.achieved}])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString($props.stepNumber), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('milestones.steps')), 1)
  ], 2))
}